var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"padding":"0","width":"100%","height":"122px","object-fit":"cover"},attrs:{"src":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }